import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart8: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-8, statistics, flipchart, presentation, graph"} maskId="square-filled-radius-0-stroke-1-IconChart8"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 17H8V12H7V17ZM11.5 17H12.5V7H11.5V17ZM16 10V17H17V10H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart8;
